export default {
  metadata: {
    version: '1.0.0',
    id: 'text-1.0.0',
    name: 'JDSText'
  },
  hierarchy: {
    text: []
  },
  base: {
    text: {
      'font-family': '{text_1}',
      color: '{text_2}',
      'font-size': '{text_3}',
      'line-height': '{text_4}',
      'letter-spacing': '{text_5}',
      'font-weight': '{text_6}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    textAlign: {
      center: {
        text: {
          'text-align': 'center'
        }
      },
      right: {
        text: {
          'text-align': 'right'
        }
      }
    },
    textDecoration: {
      underline: {
        text: {
          'text-decoration': '{text_8}'
        }
      },
      'line-through': {
        text: {
          'text-decoration': '{text_9}'
        }
      },
      overline: {
        text: {
          'text-decoration': '{text_10}'
        }
      }
    },
    color: {
      primary_80: {
        text: {
          color: '{text_11}'
        }
      },
      primary_70: {
        text: {
          color: '{text_12}'
        }
      },
      primary_60: {
        text: {
          color: '{text_13}'
        }
      },
      primary_50: {
        text: {
          color: '{text_14}'
        }
      },
      primary_40: {
        text: {
          color: '{text_15}'
        }
      },
      primary_30: {
        text: {
          color: '{text_16}'
        }
      },
      primary_20: {
        text: {
          color: '{text_17}'
        }
      },
      primary_inverse: {
        text: {
          color: '{text_18}'
        }
      },
      primary_background: {
        text: {
          color: '{text_19}'
        }
      },
      primary_grey_100: {
        text: {
          color: '{text_20}'
        }
      },
      primary_grey_80: {
        text: {
          color: '{text_21}'
        }
      },
      primary_grey_60: {
        text: {
          color: '{text_22}'
        }
      },
      primary_grey_40: {
        text: {
          color: '{text_23}'
        }
      },
      primary_grey_20: {
        text: {
          color: '{text_24}'
        }
      },
      secondary_80: {
        text: {
          color: '{text_25}'
        }
      },
      secondary_70: {
        text: {
          color: '{text_26}'
        }
      },
      secondary_60: {
        text: {
          color: '{text_27}'
        }
      },
      secondary_50: {
        text: {
          color: '{text_28}'
        }
      },
      secondary_40: {
        text: {
          color: '{text_29}'
        }
      },
      secondary_30: {
        text: {
          color: '{text_30}'
        }
      },
      secondary_20: {
        text: {
          color: '{text_31}'
        }
      },
      secondary_inverse: {
        text: {
          color: '{text_32}'
        }
      },
      secondary_background: {
        text: {
          color: '{text_33}'
        }
      },
      secondary_grey_100: {
        text: {
          color: '{text_34}'
        }
      },
      secondary_grey_80: {
        text: {
          color: '{text_35}'
        }
      },
      secondary_grey_60: {
        text: {
          color: '{text_36}'
        }
      },
      secondary_grey_40: {
        text: {
          color: '{text_37}'
        }
      },
      secondary_grey_20: {
        text: {
          color: '{text_38}'
        }
      },
      sparkle_80: {
        text: {
          color: '{text_39}'
        }
      },
      sparkle_70: {
        text: {
          color: '{text_40}'
        }
      },
      sparkle_60: {
        text: {
          color: '{text_41}'
        }
      },
      sparkle_50: {
        text: {
          color: '{text_42}'
        }
      },
      sparkle_40: {
        text: {
          color: '{text_43}'
        }
      },
      sparkle_30: {
        text: {
          color: '{text_44}'
        }
      },
      sparkle_20: {
        text: {
          color: '{text_45}'
        }
      },
      sparkle_inverse: {
        text: {
          color: '{text_46}'
        }
      },
      sparkle_background: {
        text: {
          color: '{text_47}'
        }
      },
      sparkle_grey_100: {
        text: {
          color: '{text_48}'
        }
      },
      sparkle_grey_80: {
        text: {
          color: '{text_49}'
        }
      },
      sparkle_grey_60: {
        text: {
          color: '{text_50}'
        }
      },
      sparkle_grey_40: {
        text: {
          color: '{text_51}'
        }
      },
      sparkle_grey_20: {
        text: {
          color: '{text_52}'
        }
      },
      feedback_error_80: {
        text: {
          color: '{text_53}'
        }
      },
      feedback_error_50: {
        text: {
          color: '{text_54}'
        }
      },
      feedback_error_20: {
        text: {
          color: '{text_55}'
        }
      },
      feedback_warning_80: {
        text: {
          color: '{text_56}'
        }
      },
      feedback_warning_50: {
        text: {
          color: '{text_57}'
        }
      },
      feedback_warning_20: {
        text: {
          color: '{text_58}'
        }
      },
      feedback_success_80: {
        text: {
          color: '{text_59}'
        }
      },
      feedback_success_50: {
        text: {
          color: '{text_60}'
        }
      },
      feedback_success_20: {
        text: {
          color: '{text_61}'
        }
      },
      white: {
        text: {
          color: '{text_62}'
        }
      },
      black: {
        text: {
          color: '{text_63}'
        }
      },
      transparent: {
        text: {
          color: '{text_64}'
        }
      }
    },
    appearance: {
      heading_xl: {
        text: {
          'font-size': '{text_65}',
          'line-height': '{text_67}',
          'letter-spacing': '{text_68}',
          'font-weight': '{text_69}',
          'font-family': '{text_66}'
        }
      },
      heading_l: {
        text: {
          'font-size': '{text_70}',
          'line-height': '{text_72}',
          'letter-spacing': '{text_73}',
          'font-weight': '{text_74}',
          'font-family': '{text_71}'
        }
      },
      heading_m: {
        text: {
          'font-size': '{text_75}',
          'line-height': '{text_77}',
          'letter-spacing': '{text_78}',
          'font-weight': '{text_79}',
          'font-family': '{text_76}'
        }
      },
      heading_s: {
        text: {
          'font-size': '{text_80}',
          'font-family': '{text_81}',
          'line-height': '{text_82}',
          'letter-spacing': '{text_83}',
          'font-weight': '{text_84}'
        }
      },
      heading_xs: {
        text: {
          'font-size': '{text_85}',
          'font-family': '{text_86}',
          'line-height': '{text_87}',
          'letter-spacing': '{text_88}',
          'font-weight': '{text_89}'
        }
      },
      heading_xxs: {
        text: {
          'font-size': '{text_90}',
          'line-height': '{text_92}',
          'letter-spacing': '{text_93}',
          'font-weight': '{text_94}',
          'font-family': '{text_91}'
        }
      },
      overline: {
        text: {
          'font-size': '{text_95}',
          'font-family': '{text_96}',
          'line-height': '{text_97}',
          'letter-spacing': '{text_98}',
          'font-weight': '{text_99}',
          'text-transform': '{text_100}'
        }
      },
      body_l: {
        text: {
          'font-size': '{text_101}',
          'font-family': '{text_102}',
          'line-height': '{text_103}',
          'letter-spacing': '{text_104}',
          'font-weight': '{text_105}'
        }
      },
      body_l_bold: {
        text: {
          'font-size': '{text_106}',
          'font-family': '{text_107}',
          'line-height': '{text_108}',
          'letter-spacing': '{text_109}',
          'font-weight': '{text_110}'
        }
      },
      body_l_link: {
        text: {
          'font-size': '{text_111}',
          'font-family': '{text_112}',
          'line-height': '{text_113}',
          'letter-spacing': '{text_114}',
          'font-weight': '{text_115}',
          color: '{text_0}'
        }
      },
      body_m: {
        text: {
          'font-size': '{text_116}',
          'font-family': '{text_117}',
          'line-height': '{text_118}',
          'letter-spacing': '{text_119}',
          'font-weight': '{text_120}'
        }
      },
      body_m_bold: {
        text: {
          'font-size': '{text_121}',
          'font-family': '{text_122}',
          'line-height': '{text_123}',
          'letter-spacing': '{text_124}',
          'font-weight': '{text_125}'
        }
      },
      body_m_link: {
        text: {
          'font-size': '{text_126}',
          'font-family': '{text_127}',
          'line-height': '{text_128}',
          'letter-spacing': '{text_129}',
          'font-weight': '{text_130}',
          color: '{text_0}'
        }
      },
      body_s: {
        text: {
          'font-size': '{text_131}',
          'font-family': '{text_132}',
          'line-height': '{text_133}',
          'letter-spacing': '{text_134}',
          'font-weight': '{text_135}'
        }
      },
      body_s_bold: {
        text: {
          'font-size': '{text_136}',
          'font-family': '{text_137}',
          'line-height': '{text_138}',
          'letter-spacing': '{text_139}',
          'font-weight': '{text_140}'
        }
      },
      body_s_link: {
        text: {
          'font-size': '{text_141}',
          'font-family': '{text_142}',
          'line-height': '{text_143}',
          'letter-spacing': '{text_144}',
          'font-weight': '{text_145}',
          color: '{text_0}'
        }
      },
      body_xs: {
        text: {
          'font-size': '{text_146}',
          'font-family': '{text_147}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        }
      },
      body_xs_bold: {
        text: {
          'font-size': '{text_151}',
          'font-family': '{text_152}',
          'line-height': '{text_153}',
          'letter-spacing': '{text_154}',
          'font-weight': '{text_155}'
        }
      },
      body_xs_link: {
        text: {
          'font-size': '{text_156}',
          'font-family': '{text_157}',
          'line-height': '{text_158}',
          'letter-spacing': '{text_159}',
          'font-weight': '{text_160}',
          color: '{text_0}'
        }
      },
      body_xxs: {
        text: {
          'font-size': '{text_166}',
          'font-family': '{text_167}',
          'line-height': '{text_168}',
          'letter-spacing': '{text_169}',
          'font-weight': '{text_170}'
        }
      },
      body_xxs_bold: {
        text: {
          'font-size': '{text_171}',
          'font-family': '{text_172}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      body_xxs_link: {
        text: {
          'font-size': '{text_176}',
          'font-family': '{text_177}',
          'line-height': '{text_178}',
          'letter-spacing': '{text_179}',
          'font-weight': '{text_180}',
          color: '{text_0}'
        }
      },
      list_title: {
        text: {
          'font-size': '{text_181}',
          'font-family': '{text_182}',
          'line-height': '{text_183}',
          'letter-spacing': '{text_184}',
          'font-weight': '{text_185}'
        }
      },
      button: {
        text: {
          'font-size': '{text_186}',
          'font-family': '{text_187}',
          'line-height': '{text_188}',
          'letter-spacing': '{text_189}',
          'font-weight': '{text_190}'
        }
      },
      code: {
        text: {
          'font-size': '{text_191}',
          'font-family': '{text_192}',
          'line-height': '{text_193}',
          'letter-spacing': '{text_194}',
          'font-weight': '{text_195}'
        }
      },
      body_xs_caps: {
        text: {
          'font-size': '{text_201}',
          'line-height': '{text_162}',
          'letter-spacing': '{text_164}',
          'font-weight': '{text_165}',
          'text-transform': '{text_163}',
          'font-family': '{text_161}'
        }
      },
      body_s_regular_para: {
        text: {
          'font-size': '{text_196}',
          'line-height': '{text_197}',
          'letter-spacing': '{text_198}',
          'font-weight': '{text_199}',
          'font-family': '{text_200}'
        }
      }
    }
  },
  api: {
    config: {
      color: {
        values: [
          'primary_grey_100',
          'primary_80',
          'primary_70',
          'primary_60',
          'primary_50',
          'primary_40',
          'primary_30',
          'primary_20',
          'primary_inverse',
          'primary_background',
          'primary_grey_80',
          'primary_grey_60',
          'primary_grey_40',
          'primary_grey_20',
          'secondary_80',
          'secondary_70',
          'secondary_60',
          'secondary_50',
          'secondary_40',
          'secondary_30',
          'secondary_20',
          'secondary_inverse',
          'secondary_background',
          'secondary_grey_100',
          'secondary_grey_80',
          'secondary_grey_60',
          'secondary_grey_40',
          'secondary_grey_20',
          'sparkle_80',
          'sparkle_70',
          'sparkle_60',
          'sparkle_50',
          'sparkle_40',
          'sparkle_30',
          'sparkle_20',
          'sparkle_inverse',
          'sparkle_background',
          'sparkle_grey_100',
          'sparkle_grey_80',
          'sparkle_grey_60',
          'sparkle_grey_40',
          'sparkle_grey_20',
          'feedback_error_80',
          'feedback_error_50',
          'feedback_error_20',
          'feedback_warning_80',
          'feedback_warning_50',
          'feedback_warning_20',
          'feedback_success_80',
          'feedback_success_50',
          'feedback_success_20',
          'white',
          'black',
          'transparent'
        ],
        doc_description: 'It can be used to add font-color to text.',
        function: true
      },
      textAlign: {
        values: ['left', 'right', 'center'],
        doc_description: 'It aligns text to left, center, right.'
      },
      textDecoration: {
        values: ['none', 'underline', 'line-through', 'overline'],
        doc_description:
          "It can be used to decorate text eg. 'underline', 'line-through', 'overline'."
      },
      appearance: {
        values: [
          'body_s',
          'heading_xl',
          'heading_l',
          'heading_m',
          'heading_s',
          'heading_xs',
          'heading_xxs',
          'overline',
          'body_l',
          'body_l_bold',
          'body_l_link',
          'body_m',
          'body_m_bold',
          'body_m_link',
          'body_s_bold',
          'body_s_link',
          'body_xs',
          'body_xs_bold',
          'body_xs_link',
          'body_xxs',
          'body_xxs_bold',
          'body_xxs_link',
          'list_title',
          'button',
          'code',
          'body_xs_caps',
          'body_s_regular_para'
        ],
        doc_description:
          'It can be used to set a font appearance based on our typography rules.'
      }
    },
    data: {
      text: {
        value: {
          type: 'string',
          name: 'text',
          doc_description: 'It the user input text.'
        },
        'max-lines': {
          type: 'number',
          name: 'maxLines',
          function: true,
          doc_description:
            'It determines the maximum lines of text the user can pass as input.'
        },
        'min-lines': {
          type: 'number',
          name: 'minLines',
          platform: 'android',
          doc_description:
            'It determines the minimum lines of text the user can pass as input.'
        },
        textType: {
          type: 'string',
          name: 'textType',
          platform: 'web'
        },
        'custom-color': {
          type: 'color',
          name: 'customColor',
          platform: 'android'
        }
      }
    },
    events: {
      text: {
        onTextLayout: {
          name: 'onTextLayout',
          platform: 'android'
        }
      }
    }
  }
};
